import { useEffect, useState } from "react"
import { getAdminLessonVideoStreamApi, LessonVideoStream } from "../api/lesson.api"
import { ExclamationTriangleIcon } from "@heroicons/react/16/solid"

type Props = {
  lessonId: string
  /** Bump to force a refetch — e.g. right after a newly uploaded video finishes processing. */
  refreshKey?: number | string
}

export const LessonVideoPlayer = ({ lessonId, refreshKey }: Props) => {
  const [stream, setStream] = useState<LessonVideoStream | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    setLoading(true)
    setError(false)
    getAdminLessonVideoStreamApi(lessonId)
      .then((res) => setStream(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [lessonId, refreshKey])

  if (loading) return <div className="aspect-video bg-gray-100 rounded-xl animate-pulse" />

  if (error || !stream) {
    return (
      <div className="aspect-video rounded-xl bg-gray-50 border border-gray-100 flex flex-col items-center justify-center gap-2 text-gray-400">
        <ExclamationTriangleIcon className="w-6 h-6" />
        <p className="text-sm">Видео недоступно</p>
      </div>
    )
  }

  return (
    <div className="aspect-video rounded-xl overflow-hidden bg-black">
      <iframe
        src={stream.embed_url}
        title="Видео урока"
        className="w-full h-full"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen
      />
    </div>
  )
}
